/* Solar Ai Theme — theme.js */
document.addEventListener('DOMContentLoaded', function () {

  // NAV scroll shadow
  var nav = document.getElementById('sa-nav');
  var scrollTop = document.getElementById('sa-scroll-top');
  window.addEventListener('scroll', function () {
    if (nav) nav.style.boxShadow = window.scrollY > 60 ? '0 4px 40px rgba(27,58,107,0.1)' : 'none';
    if (scrollTop) scrollTop.classList.toggle('visible', window.scrollY > 500);
  });

  // Mobile menu
  var hamburger = document.getElementById('sa-hamburger');
  var mobileMenu = document.getElementById('sa-mobile-menu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () { mobileMenu.classList.toggle('open'); });
  }
  document.querySelectorAll('.sa-mobile-close').forEach(function (el) {
    el.addEventListener('click', function () { if (mobileMenu) mobileMenu.classList.remove('open'); });
  });

  // Scroll top
  if (scrollTop) scrollTop.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });

  // Smooth anchor scroll
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector(a.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
        if (mobileMenu) mobileMenu.classList.remove('open');
      }
    });
  });

  // Contact form
  var form = document.getElementById('sa-quote-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var toast = document.getElementById('sa-toast');
      if (toast) {
        toast.classList.add('show');
        setTimeout(function () { toast.classList.remove('show'); }, 4500);
      }
      form.reset();
    });
  }

  // Scroll reveal
  var revealEls = document.querySelectorAll('.sa-reveal, .sa-reveal-left, .sa-reveal-right');
  var revealObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        revealObs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
  revealEls.forEach(function (el) { revealObs.observe(el); });

});
